export const isDevelop = (isFront?: boolean) => {
  const isEnvDevelopment = process.env.NODE_ENV === "development";
  const isTestServer = isFront
    ? window.location.hostname === "front.taprewards.io"
    : false;

  return isEnvDevelopment || isTestServer;
};
